import React, { useEffect, createElement } from 'react';
import { WaterfordHeroInfo } from './waterford/WaterfordHeroInfo';
import { WaterfordHeroForm } from './waterford/WaterfordHeroForm';
import { WaterfordDistance } from './waterford/WaterfordDistance';
import { WaterfordWhy } from './waterford/WaterfordWhy';
import { WaterfordPrograms } from './waterford/WaterfordPrograms';
import { WaterfordScheduleLocation } from './waterford/WaterfordScheduleLocation';
import { WaterfordReviews } from './waterford/WaterfordReviews';
import { WaterfordFAQHeader } from './waterford/WaterfordFAQHeader';
import { WaterfordFAQQuestions } from './waterford/WaterfordFAQQuestions';
import { WaterfordLinks } from './waterford/WaterfordLinks';
import { WaterfordFinalCTA } from './waterford/WaterfordFinalCTA';
export function Waterford() {
  useEffect(() => {
    document.title = 'Martial Arts & Taekwondo Near Waterford, MI | Storm';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Looking for martial arts near Waterford? Storm Taekwondo offers premium kids and family classes. Try one week free.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Looking for martial arts near Waterford? Storm Taekwondo offers premium kids and family classes. Try one week free.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-3498">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-3499">
        <div className="absolute inset-0 opacity-20" data-id="element-3500">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-3501" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-3502" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3503">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-3504">
            <WaterfordHeroInfo data-id="element-3505" />
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-3506">
              <WaterfordHeroForm data-id="element-3507" />
            </div>
          </div>
        </div>
      </section>

      <WaterfordDistance data-id="element-3508" />
      <WaterfordWhy data-id="element-3509" />
      <WaterfordPrograms data-id="element-3510" />
      <WaterfordScheduleLocation data-id="element-3511" />
      <WaterfordReviews data-id="element-3512" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-3513">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3514">
          <WaterfordFAQHeader data-id="element-3515" />
          <WaterfordFAQQuestions data-id="element-3516" />
        </div>
      </section>
      <WaterfordLinks data-id="element-3517" />
      <WaterfordFinalCTA data-id="element-3518" />
    </div>;
}